import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'ui';
import { WithCharacterBackground } from 'ui/characters';
import RoundedHeader from 'ui/layouts/RoundedHeader';
import { classNameType, colorType } from 'utils/types';

import s from './SinglePersonalityHeader.module.scss';

const cx = cn.bind(s);

const SinglePersonalityHeader = ({
  color,
  character,
  title,
  info,
  characterExtra,
  className,
  infoColumnClassName,
  ...attrs
}) => (
  <RoundedHeader color={color} className={cx(className, 'header')}{...attrs}>
    <Container>
      <Row>
        <Col
          xs={12}
          md={{
            offset: 1,
            span: 11,
          }}
          lg={4}
          xl={{
            offset: 1,
            span: 5,
          }}
          className={cx('infoColumn', infoColumnClassName)}
        >
          <h1
            className={cx(
              'title',
              'tp-mobile-header-1 md:tp-tablet-header-1 xl:tp-header-1',
            )}
          >
            {title}
          </h1>
          <h3 className={cx('info', color)}>{info}</h3>
        </Col>
        <Col xs={12}
          md={{
            offset: 2,
            span: 8,
          }}
          lg={{
            offset: 0,
            span: 6,
          }}
          xl={{
            offset: 0,
            span: 4,
          }}
        >
          <div className={cx('imageColumnContent')}>
            <WithCharacterBackground
              color={color}
              transparent={false}
              extra={characterExtra}
              position="fill"
            >
              {character || null}
            </WithCharacterBackground>
          </div>
        </Col>
      </Row>
    </Container>
  </RoundedHeader>
);

SinglePersonalityHeader.propTypes = {
  className: classNameType,
  color: colorType,
  skinTone: PropTypes.oneOf([1, 2, 3, 4, 5]),
  character: PropTypes.element,
  characterExtra: PropTypes.element,
  info: PropTypes.string,
};

export default SinglePersonalityHeader;
